import { AdvertiserTree } from "./components/AdvertiserTree";

export const OverviewPage = () => {
  return (
      <AdvertiserTree/>
  );
};
